<script setup lang="ts">
import { IconWifiOff } from '@tabler/icons-vue';
import { useOnline } from '@vueuse/core';

const isOnline = useOnline();
</script>

<template>
    <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="-translate-y-full opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="-translate-y-full opacity-0"
    >
        <div
            v-if="!isOnline"
            role="status"
            aria-live="polite"
            class="fixed inset-x-0 top-0 z-modal flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow"
        >
            <IconWifiOff
                class="size-4"
                aria-hidden="true"
            />
            <span>Geen internetverbinding — wijzigingen kunnen niet worden opgeslagen.</span>
        </div>
    </Transition>
</template>
